import store from '../store';

export default class Loader
{
    static show(text: string|null = 'Bitte warten Sie, während Sie weitergeleitet werden.')
    {
        store.commit('loader', {
            active: true,
            text,
        });
    }

    static hide()
    {
        store.commit('loader', {
            active: false,
        });
    }

    static setText(text: string)
    {
        store.commit('loader', {
            active: store.state.loader.active,
            text,
        });
    }
}
